import { Component } from '@angular/core';

import { SimulatorType } from '../../../../core/enums/simulator-type.enum';
import { SimulatorConfig } from '../../../../core/models/simulation.model';
import { BasicUpscalingSimulatorComponent } from '../../../../common/basic-upscaling-simulator/basic-upscaling-simulator.component';

@Component({
  selector: 'app-upscaling-absolute-permeability',
  imports: [BasicUpscalingSimulatorComponent],
  standalone: true,
  templateUrl: './absolute-permeability.component.html',
  styleUrl: './absolute-permeability.component.scss',
})
export class UpscalingAbsolutePermeabilityComponent {
  readonly config: SimulatorConfig = {
    title: 'Upscaling - Absolute Permeability Simulation',
    simulatorType: SimulatorType.UpscalingKabs,
  };
}
